import { useState } from "react";
import * as XLSX from "xlsx";

export function useCreate() {
    const [tableHeaders, setTableHeaders] = useState<string[]>([]);
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [type, setType] = useState<"ticket" | "user" | "organization">("ticket");
    const [result, setResult] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    function handleFile(file: File) {
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target?.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            const headers = json[0];
            const rows = json.slice(1);

            setTableHeaders(headers as string[]);
            setTableRows(rows);
        };

        reader.readAsArrayBuffer(file);
    }

    function handleFileRemoved() {
        setTableHeaders([]);
        setTableRows([]);
    }

    return {
        type,
        setType,
        tableHeaders,
        setTableHeaders,
        tableRows,
        setTableRows,
        handleFile,
        handleFileRemoved,
        result,
        setResult,
        loading,
        setLoading
    }
}